<template>
  <div class="static-page-wrapper" v-html="pageContent"></div>
</template>

<script>
import Utility from "../helpers/utility";
import { clientPlatform } from "../config/apiEndpoints";

export default {
  name: "HtmlComponent",
  components: {
    //
  },
  props: ["dataResults"],
  data() {
    return {
      pageContent: [],
      clientPlatform,
    };
  },
  mounted() {
    if (
      this.dataResults != "null" &&
      typeof this.dataResults != "undefined" &&
      typeof this.dataResults
    ) {
      let platformId = clientPlatform == "Web" ? 5 : 4;
      this.pageContent =
        JSON.parse(this.dataResults)?.find((x) => x.platform_id == platformId)
          ?.page_content || "Something went wrong, pls try again!";
    }
    setTimeout(() => {
      const assetName = Utility.getQueryFromUrl()["assetName"];
      if (document.getElementById("infoHeader")) {
        if (assetName === "app") {
          document.getElementById("infoHeader").style.display = "none";
        } else {
          document.getElementById("infoHeader").style.display = "block";
        }
      }
    }, 0);
  },
  methods: {
    //
  },
};
</script>
